import React from 'react';
import { Link } from 'react-router-dom';

const CTA_BANNERS = [
    {
        id: 'providers',
        title: 'Sign up now & put your services on the platform!',
        text: 'Launching our global marketplace for products and services—join early and showcase your offerings to customers worldwide.',
        buttonLabel: 'Sign up as a seller',
        route: '/seller/register',
        buttonClass: 'btn_yellow',
    },
    {
        id: 'buyers',
        title: 'Discover trusted products and professional services.',
        text: 'Browse our growing global marketplace today!',
        buttonLabel: 'Browse services',
        route: '/service-listing',
        buttonClass: 'btn_yellow_bordered',
    },
];

const HomeCtaBanners = () => {
    return (
        <section className="home_cta_banners py-4">
            <div className="container">
                <div className="row g-3">
                    {CTA_BANNERS.map((banner) => (
                        <div key={banner.id} className="col-12 col-md-6">
                            <div className="card h-100 shadow-sm border-0">
                                <div className="card-body d-flex flex-column p-4">
                                    <h4 className="h5 fw-bold mb-2">{banner.title}</h4>
                                    <p className="mb-3 flex-grow-1">{banner.text}</p>
                                    <div>
                                        <Link to={banner.route} className={`btn custom_btn w-auto px-4 ${banner.buttonClass}`}>
                                            {banner.buttonLabel}
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default HomeCtaBanners;
